module.exports = __webpack_public_path__ + "img/setting20221114.f6ea57ef.png";